import { add, DateString, Hours } from "@pentacode/openapi";
import { NominalHoursMode } from "./model";

interface SalaryLike {
    positionId: number | null;
}

export function getDefaultSalary<T extends SalaryLike>(salaries: T[]) {
    return salaries.find((s) => s.positionId === null);
}

export function hasFixedWorkDays(mode: NominalHoursMode) {
    return [NominalHoursMode.FixedDays, NominalHoursMode.FixedDaysWithoutHolidays].includes(mode);
}

export function getNominalWeeklyHours(props: {
    nominalHoursMode: NominalHoursMode;
    hoursPerDay?: Hours[] | null;
    hoursPerWeek?: Hours | null;
}) {
    return hasFixedWorkDays(props.nominalHoursMode)
        ? props.hoursPerDay?.reduce((total, day) => add(total, day), 0 as Hours) || (0 as Hours)
        : props.hoursPerWeek || (0 as Hours);
}

export function getSalaryOrDefault<T extends SalaryLike>(
    positionId: number | null | undefined,
    salaries: T[]
): T | undefined {
    // Try to find position-specific salary first
    return (
        salaries.find((salary) => salary.positionId === positionId) ||
        // Otherwise choose default salary (no position attached)
        getDefaultSalary(salaries)
    );
}

export function isActiveOn(date: DateString, range: { start: DateString; end: DateString | null }) {
    return range.start <= date && (!range.end || range.end > date);
}
